export default class DropdownMenu {
	constructor($root, options = {}) {
		this.$root = $root;
		this.$trigger = null;
		this.$triggerLabel = null;
		this.$options = null;
		this.$currentActive = null;

		this.initialValue = options.initialValue || null;
		this.associated = options.associated || [];

		this.OPTION_CHANGE_EVENT = 'optionChange';

		this.init();
	}

	init() {
		if (this.$root == null) {
			throw new Error('DropdownMenu: Root element is not defined.');
		}

		this.$trigger = this.$root.querySelector('[data-dropdown-menu="trigger"]');
		this.$triggerLabel = this.$trigger.querySelector('.dropdown-menu-btn_label');
		this.$options = this.$root.querySelectorAll('[data-dropdown-menu="option"]');

		if (this.initialValue) {
			this.changeOptionByValue(this.initialValue);
		}

		this.addEventListeners();
		this.$trigger.removeAttribute('disabled');
	}

	addEventListeners() {
		/* Trigger Listener */
		this.$trigger.addEventListener('click', () => {
			this.open();
		});

		/* Close Listener */
		window.addEventListener('click', e => {
			if (e.target.closest('[data-dropdown-menu="root"]')) {
				return;
			}

			this.close();
		});

		/* Option Change Listener */
		this.$options.forEach(($option) => {
			$option.addEventListener('click', () => {
				this.changeOption($option);
			});
		});
	}

	changeOptionByValue(value, shouldDispatch = true) {
		shouldDispatch = shouldDispatch === false ? shouldDispatch : true;

		const $newActive = Array.from(this.$options).find(($option) => $option.dataset.value === value);
		if (!$newActive) return;
		this.changeOption($newActive, shouldDispatch);
	}

	changeOnFirst(shouldDispatch = true) {
		shouldDispatch = shouldDispatch === false ? shouldDispatch : true;

		this.changeOption(this.$options[0], shouldDispatch);
	}

	changeOption($option, shouldDispatch = true) {
		shouldDispatch = shouldDispatch === false ? shouldDispatch : true;

		if (this.$currentActive === $option) return;

		if (this.$currentActive != null) {
			this.$currentActive.classList.remove('-active');
		}

		$option.classList.add('-active');
		this.$currentActive = $option;
		this.$triggerLabel.textContent = $option.textContent;

		if (shouldDispatch) {
			this.dispatchOptionChangeEvent();
		}
		this.close();
	}

	dispatchOptionChangeEvent() {
		this.$root.dispatchEvent(new CustomEvent(this.OPTION_CHANGE_EVENT, { detail: this.$currentActive }));
	}

	open() {
		this.$root.classList.toggle('-show');
		this.$trigger.classList.toggle('-active');

		if (this.associated.length) {
			this.associated.forEach((dropdownInstance) => {
				if (dropdownInstance instanceof DropdownMenu) {
					dropdownInstance.close();
				}
			});
		}
	}

	close() {
		this.$root.classList.remove('-show');
		this.$trigger.classList.remove('-active');
	}
}